import { Component } from 'solid-js'
import { RootModal } from '/web/shared/Modal'
import { getAssetUrl } from '/web/shared/util'
import { i18nStore } from '/web/store'

export const AvatarModal: Component<{ url?: string; close: () => void }> = (props) => {
  const i18n = i18nStore((s) => s)
  return (
    <RootModal
      show={!!props.url}
      close={props.close}
      maxWidth="half"
      fixedHeight
      title={i18n.t.chat_avatar_modal_title}
    >
      <div class="flex justify-center p-4">
        <img class="rounded-md" src={getAssetUrl(props.url!)} />
      </div>
    </RootModal>
  )
}
